export default "__VITE_ASSET__BBIQX7ue__"